(function () {
  var KEY = 'tlv_wl';
  var style = document.createElement('style');
  style.textContent = 'html body .pc-heart{width:28px!important;height:28px!important;min-width:28px!important;min-height:28px!important;margin:0!important;position:relative;z-index:12;touch-action:manipulation}html body .pc-heart::after{content:"";position:absolute;inset:-8px;background:transparent;touch-action:manipulation}html body .pc-heart svg{width:28px!important;height:28px!important;pointer-events:none;stroke-width:1.9}html body .pc-heart:focus-visible{outline:2px solid #ff42a1!important;outline-offset:2px!important}';
  style.textContent += '#MainContent .pc-heart.pc-heart{flex:0 0 36px!important;width:36px!important;height:36px!important;min-width:36px!important;min-height:36px!important;z-index:12!important}#MainContent .pc-heart.pc-heart svg{width:30px!important;height:30px!important;fill:none!important;stroke:#59796a!important;stroke-width:1.9!important}#MainContent .pc-heart.pc-heart.is-on svg{fill:#ff42a1!important;stroke:#ff42a1!important}html body .drift-card .drift-heart.drift-heart{width:40px!important;height:40px!important;min-width:40px!important;min-height:40px!important;z-index:30!important;pointer-events:auto!important;touch-action:manipulation!important;transform:rotate(calc(var(--rot,0deg)* -1))!important}html body .drift-card .drift-heart.drift-heart svg{width:27px!important;height:27px!important;min-width:27px!important;min-height:27px!important;pointer-events:none!important}';
  style.textContent += '#MainContent .product-main__main-image .pc-heart.pdp-wl.pc-heart{position:absolute!important;top:auto!important;right:12px!important;bottom:12px!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;margin:0!important;display:flex!important;align-items:center!important;justify-content:center!important;z-index:12!important;cursor:pointer!important;pointer-events:auto!important}#MainContent .product-main__main-image .pc-heart.pdp-wl.pc-heart svg{width:28px!important;height:28px!important;pointer-events:none}#MainContent .product-main__main-image .pc-heart.pdp-wl.pc-heart::after{inset:-4px!important}';
  document.head.appendChild(style);  ['pointerdown','mousedown','touchstart'].forEach(function(type){
    document.addEventListener(type,function(event){
      if(event.target.closest('.pc-heart'))event.stopPropagation();
    },true);
  });

  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (error) { return []; }
  }

  function saveItems(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); }
    catch (error) {}
  }

  function paint() {
    var items = getItems();
    var handles = items.map(function (item) { return item.h; });
    document.querySelectorAll('.pc-heart').forEach(function (heart) {
      var active = handles.indexOf(heart.dataset.h) > -1;
      heart.classList.toggle('is-on', active);
      if (heart.getAttribute('aria-pressed') !== String(active)) heart.setAttribute('aria-pressed', String(active));
    });

    var count = document.getElementById('tlv-wl-count');
    if (count) {
      var value = items.length ? String(items.length) : '';
      if (count.textContent !== value) count.textContent = value;
      count.classList.toggle('has', items.length > 0);
    }
  }

  window.tlvWl = {
    get: getItems,
    set: function (items) { saveItems(items); paint(); },
    paint: paint
  };

  document.addEventListener('click', function (event) {
    var heart = event.target.closest('.pc-heart');
    if (!heart) return;
    event.preventDefault();
    event.stopPropagation();

    var items = getItems();
    var index = items.findIndex(function (item) { return item.h === heart.dataset.h; });
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.unshift({ h: heart.dataset.h, t: heart.dataset.t, p: heart.dataset.p, i: heart.dataset.i });
      heart.classList.remove('pop');
      void heart.offsetWidth;
      heart.classList.add('pop');
      if (window.gtag) window.gtag('event', 'add_to_wishlist', { item_id: heart.dataset.h });
    }
    saveItems(items);
    paint();
  }, true);

  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.classList && event.target.classList.contains('pc-heart')) {
      event.preventDefault();
      event.target.click();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();

  /* TLV-SCOPED-WISHLIST-PAINT-20261023 */
  new MutationObserver(function (muts) {
    if (!muts.some(function(m){return Array.prototype.some.call(m.addedNodes,function(n){return n.nodeType===1&&(n.matches('.pc-heart')||n.querySelector('.pc-heart'));});})) return;
    clearTimeout(window.__wlT);
    window.__wlT = setTimeout(paint, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

